// ./ui/BuyButton.jsx
import React, { useState } from "react";
import { Button } from "./button";

export default function BuyButton() {
  const [showInfo, setShowInfo] = useState(false);
  const contractAddress = "0x18A05C5d0B5787aaBE64d209997fbFfa3Df77283";

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const url = "https://app.hercules.exchange/";

  const handleClick = () => {
    if (isIOS) {
      // iOS: open MetaMask app via deep link
      window.location.href = "metamask://dapp/regret-roulette.pages.dev/";
    } else {
      // Desktop or Android
      if (!showInfo) {
        setShowInfo(true);
      } else {
        window.open(url, "_blank");
      }
    }
  };

  return (
    <div className="flex flex-col items-end space-y-2">
      <Button
        onClick={handleClick}
        className="bg-green-600 hover:bg-green-500 text-white text-sm font-bold px-4 py-2 rounded w-[210px] text-center"
      >
        {showInfo ? "Go to Hercules Exchange ↗" : "Buy $REGRET"}
      </Button>

      {showInfo && !isIOS && (
        <div className="relative text-xs text-white text-right max-w-[220px] leading-tight p-2 border border-cyan-600 rounded-md bg-gray-800">
          <button
            onClick={() => setShowInfo(false)}
            className="absolute top-0 right-1 text-cyan-400 text-lg leading-none hover:text-white"
            aria-label="Close"
          >
            &times;
          </button>
          <p>
            Connect your wallet (top right), then search for{" "}
            <span className="font-semibold text-green-300">REGRET</span> or paste
            this contract address:
          </p>
          <span className="text-cyan-400 break-all block mt-1">
            {contractAddress}
          </span>
        </div>
      )}
    </div>
  );
}
